import { TTwoDragDirection, TTwoDragRejectReason, TTwoDragSide } from './types';

export type ITwoDragMoveDecision = {
  allowed: true;
  actionType: 'move';
} | {
  allowed: false;
  actionType: 'move';
  reason: TTwoDragRejectReason;
};

export interface ITwoDragMoveDecisionParams {
  from: TTwoDragSide;
  to: TTwoDragSide;
  direction: TTwoDragDirection;
  topSortable: boolean;
  bottomSortable: boolean;
}

/**
 * 二端拖拽的纯判定：用于 onMove 内部做非法落点/方向/同框排序校验。
 * - 允许：返回 { allowed: true }
 * - 拒绝：返回 { allowed: false, reason }
 */
export const getMoveDecision = (
  params: ITwoDragMoveDecisionParams,
): ITwoDragMoveDecision => {
  const { from, to, direction, topSortable, bottomSortable } = params;

  if (from === to) {
    const sortable = from === 'top' ? topSortable : bottomSortable;
    if (!sortable) {
      return {
        allowed: false,
        actionType: 'move',
        reason: 'sortable_disabled',
      };
    }

    return { allowed: true, actionType: 'move' };
  }

  // 跨框：根据 direction 允许的方向判断
  const isTopToBottomAllowed = from === 'top' && to === 'bottom';
  const isBottomToTopAllowed = from === 'bottom' && to === 'top';

  const crossAllowed = (() => {
    if (direction === 'bidirectional') return true;
    if (direction === 'topToBottomOnly') return isTopToBottomAllowed;
    if (direction === 'bottomToTopOnly') return isBottomToTopAllowed;
    return false;
  })();

  if (!crossAllowed) {
    return {
      allowed: false,
      actionType: 'move',
      reason: 'direction_not_allowed',
    };
  }

  // actionType 在首版统一按 move 口径（后续可根据 onAdd/onRemove 精细化）
  return { allowed: true, actionType: 'move' };
};

